import React, { Component } from "react";
import { connect } from "react-redux";
import { updateGlobalErrorMessage } from "../../../actions/globalError";
import {
  updateCurrentMenu,
  updateCancelRecurringAppointmentVisibility
} from "../../../actions/menu";
import { Modal } from "semantic-ui-react";
import { updateBooking } from "../../../actions/booking";
import {
  toApiDateTime,
  convertApiUtcToLocalMoment,
  convertTimeFromApi,
  convertDateTimeFromApi
} from "../../../utils/helpers";
import { clone } from "../../../reducers/helper";

@connect(mapStateToProps)
export default class CancelRecurringAppointment extends Component {
  constructor(props) {
    super(props);
  }

  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close"
      }
    });
    window.dispatchEvent(event);
  };

  closeAndSave = applyto => {
    let {
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
      appointmentStepDataBeforeUserHasMadeAnyChanges,
      customerProfileData,
      apiCustomerProfileData,
      currentBookingId,
      appointmentStepData,
      advancedAppointmentStepData,
      closeAppWhenRecursiveAppointmentModalCloses,
      gotValidOffer,
      isMultiServiceAppointment,
      advancedAppointmentStepDataFromLastSave
    } = this.props;
    let {
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      selectedDateBeforeWeOverrodeRecurringAppointment
    } = appointmentStepData;

    let payload = {};
    if (applyto && applyto === "thisonly") {
      payload = { applyto: "thisonly" };
    } else if (applyto && applyto === "thisandfuture") {
      payload = { applyto: "thisandfuture" };
    }
    let cb = () => {
      this.closeApp();
    };
    let oldStartTime = null;
    if (
      selectedTimeBeforeWeOverrodeRecurringAppointment &&
      selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
    )
      oldStartTime = toApiDateTime(
        selectedDateBeforeWeOverrodeRecurringAppointment,
        selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue,
        appointmentStepData.timeList
      );

    let firstOneInTheSeries;

    if (currentBookingId && applyto != "thisonly") {
      //cancel everything
      //this old start time is required because of how recurring works, if we dont pass it the appointment will collide with itself
      payload.status = 5;
      this.props.dispatch(
        updateBooking(
          appointmentStepData,
          advancedAppointmentStepData,
          currentBookingId,
          payload.status,
          payload.applyto,
          cb,
          isMultiServiceAppointment,
          gotValidOffer,
          oldStartTime,
          advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
        )
      );
    } else if (
      currentBookingId &&
      applyto == "thisonly" &&
      !this.isCurrentAppointmentFirstInTheSeriesOfRecurring()
    ) {
      //cancel this one
      //when date is different we do splitfrom
      payload.applyto = "thisonly";
      payload.status = 5;
      advancedAppointmentStepData.recurringToggleOn = false;

      let startTimeBeforeChanges = toApiDateTime(
        appointmentStepDataBeforeUserHasMadeAnyChanges.multiServiceList[0]
          .selectedDate,
        appointmentStepDataBeforeUserHasMadeAnyChanges.multiServiceList[0]
          .selectedTime.stringValue,
        appointmentStepData.timeList
      );

      let startTimeAfterChanges = toApiDateTime(
        appointmentStepData.multiServiceList[0].selectedDate,
        appointmentStepData.multiServiceList[0].selectedTime.stringValue,
        appointmentStepData.timeList
      );
      if (startTimeBeforeChanges == startTimeAfterChanges) {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            null,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      } else {
        this.props.dispatch(
          updateBooking(
            appointmentStepData,
            advancedAppointmentStepData,
            currentBookingId,
            payload.status,
            payload.applyto,
            cb,
            isMultiServiceAppointment,
            gotValidOffer,
            oldStartTime,
            advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
          )
        );
      }
    } else {
      //cancel this one since its first one

      payload.applyto = "thisonly";
      advancedAppointmentStepData.recurringToggleOn = false;
      payload.status = 5;
      let clonedStepData = clone(appointmentStepData);
      clonedStepData.multiServiceList[0].selectedDate =
        appointmentStepData.multiServiceList[0].originalDateOfFirstAppointmentInRecurringSeries;
      clonedStepData.multiServiceList[0].selectedTime =
        appointmentStepData.multiServiceList[0].originalTimeOfFirstAppointmentInRecurringSeries;

      this.props.dispatch(
        updateBooking(
          clonedStepData,
          advancedAppointmentStepData,
          currentBookingId,
          payload.status,
          payload.applyto,
          cb,
          isMultiServiceAppointment,
          gotValidOffer,
          oldStartTime,
          advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
        )
      );
    }
  };

  closeModal = () => {
    let isVisible = false;
    this.props.dispatch(updateCancelRecurringAppointmentVisibility(isVisible));
  };

  isCurrentAppointmentFirstInTheSeriesOfRecurring = () => {
    let {
      bookingTimesUsedForRecurring,
      timeList,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
    } = this.props.appointmentStepData;

    let isFirstInTheSeries = true;

    if (
      bookingTimesUsedForRecurring &&
      selectedTimeBeforeWeOverrodeRecurringAppointment &&
      selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
    ) {
      let foundIndex = -1;
      bookingTimesUsedForRecurring.map((o, index) => {
        let convertedTime = convertApiUtcToLocalMoment(
          o.slotstarttime,
          window.userTimezone
        );
        let newTime = convertTimeFromApi(convertedTime);
        let newDate = convertDateTimeFromApi(convertedTime);
        let dateOnWhichAppointmentWasOpened = toApiDateTime(
          selectedDateBeforeWeOverrodeRecurringAppointment,
          selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue,
          timeList
        );
        let serverDateConvertedToLocalTime = toApiDateTime(
          newDate,
          newTime.stringValue,
          timeList
        );
        if (serverDateConvertedToLocalTime == dateOnWhichAppointmentWasOpened) {
          selectedDateBeforeWeOverrodeRecurringAppointment = newDate;
          selectedTimeBeforeWeOverrodeRecurringAppointment = newTime;
          foundIndex = index;
        }
      });
      if (foundIndex != 0) {
        isFirstInTheSeries = false;
      }
    }
    return isFirstInTheSeries;
  };

  isCurrentAppointmentLastInTheSeriesOfRecurring = () => {
    let {
      bookingTimesUsedForRecurring,
      timeList,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedTimeBeforeWeOverrodeRecurringAppointment
    } = this.props.appointmentStepData;

    let lastInTheSeries = true;

    if (
      bookingTimesUsedForRecurring &&
      selectedTimeBeforeWeOverrodeRecurringAppointment &&
      selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
    ) {
      let foundIndex = -1;
      bookingTimesUsedForRecurring.map((o, index) => {
        let convertedTime = convertApiUtcToLocalMoment(
          o.slotstarttime,
          window.userTimezone
        );
        let newTime = convertTimeFromApi(convertedTime);
        let newDate = convertDateTimeFromApi(convertedTime);
        let dateOnWhichAppointmentWasOpened = toApiDateTime(
          selectedDateBeforeWeOverrodeRecurringAppointment,
          selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue,
          timeList
        );
        let serverDateConvertedToLocalTime = toApiDateTime(
          newDate,
          newTime.stringValue,
          timeList
        );
        if (serverDateConvertedToLocalTime == dateOnWhichAppointmentWasOpened) {
          selectedDateBeforeWeOverrodeRecurringAppointment = newDate;
          selectedTimeBeforeWeOverrodeRecurringAppointment = newTime;
          foundIndex = index;
        }
      });
      if (foundIndex != bookingTimesUsedForRecurring.length - 1) {
        lastInTheSeries = false;
      }
    }
    return lastInTheSeries;
  };

  getNextDateAndTimeOfSequence = () => {
    let {
      bookingTimesUsedForRecurring,
      timeList,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
    } = this.props.appointmentStepData;

    let dateAndTimeOfNextAppointment = null;

    if (
      bookingTimesUsedForRecurring &&
      bookingTimesUsedForRecurring.length > 0 &&
      selectedTimeBeforeWeOverrodeRecurringAppointment &&
      selectedTimeBeforeWeOverrodeRecurringAppointment.stringValue
    ) {
      let futureDateTime = bookingTimesUsedForRecurring[1];
      let convertedTime = convertApiUtcToLocalMoment(
        futureDateTime.slotstarttime,
        window.userTimezone
      );
      dateAndTimeOfNextAppointment = {
        newTime: convertTimeFromApi(convertedTime),
        newDate: convertDateTimeFromApi(convertedTime)
      };
    }
    return dateAndTimeOfNextAppointment;
  };

  render() {
    let {
      cancelRecurringAppointmentVisible,
      savingBooking,
      loadingBooking
    } = this.props;
    let {
      bookingTimesUsedForRecurring,
      timeList,
      selectedDateBeforeWeOverrodeRecurringAppointment,
      selectedTimeBeforeWeOverrodeRecurringAppointment,
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot
    } = this.props.appointmentStepData;

    if (!cancelRecurringAppointmentVisible) {
      return "";
    }

    let discardChangesAndGoBack = () => {
      this.closeModal();
      this.props.dispatch(updateGlobalErrorMessage(""));
    };

    let showThisAndFutureOption = !this.isCurrentAppointmentLastInTheSeriesOfRecurring();

    let saveThisOnlyButtonClasses = "ui button savebtn this-only";
    let saveAllButtonClasses = "ui button savebtn all-recurring";
    let discardButtonClasses = "ui button cancel-btn";
    let {
      No,
      CancelThisOnly,
      CancelThisAndFuture
    } = window.APP.LANGUAGE.Shared.PopupWindows;
    let {
      CancelRecurringAppTextThisOnly,
      CancelRecurringAppText
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    if (savingBooking || loadingBooking) {
      saveThisOnlyButtonClasses += " disabled";
      saveAllButtonClasses += " disabled";
      discardButtonClasses += " disabled";
    }

    return (
      <Modal
        className="bookingdetails-model cancel-recursive-appointment-confirmation transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div
            className={`save-box ${
              showThisAndFutureOption
                ? "save-recurring"
                : "save-recurring-this-only-option"
            }`}
          >
            <section className="header">
              {window.APP.LANGUAGE.Pages.Appointment.ConfirmCancel}
              <p className="save_text">
                {showThisAndFutureOption
                  ? CancelRecurringAppText
                  : CancelRecurringAppTextThisOnly}
              </p>
              {triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot ? (
                ""
              ) : (
                <button
                  type="button"
                  className="close_button"
                  onClick={this.closeModal}
                ></button>
              )}
            </section>
            <section className="save_box_buttons">
              <div
                className={discardButtonClasses}
                onClick={discardChangesAndGoBack}
              >
                {No}
              </div>
              <div
                className={saveThisOnlyButtonClasses}
                onClick={this.closeAndSave.bind(this, "thisonly")}
              >
                {CancelThisOnly}
              </div>
              {showThisAndFutureOption ? (
                <div
                  className={saveAllButtonClasses}
                  onClick={this.closeAndSave.bind(this, "thisandfuture")}
                >
                  {CancelThisAndFuture}
                </div>
              ) : (
                ""
              )}
            </section>
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    cancelRecurringAppointmentVisible:
      state.menuReducer.cancelRecurringAppointmentVisible,
    savingBooking: state.bookingReducer.savingBooking,
    loadingBooking: state.bookingReducer.loadingBooking,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    appointmentStepDataBeforeUserHasMadeAnyChanges:
      state.appointmentStepReducer
        .appointmentStepDataBeforeUserHasMadeAnyChanges,
    closeAppWhenRecursiveAppointmentModalCloses:
      state.menuReducer.closeAppWhenRecursiveAppointmentModalCloses,
    apiCustomerProfileData: state.customerProfileReducer.apiCustomerProfileData,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    customerProfileData: state.customerProfileReducer.customerProfileData,
    currentBookingId: state.bookingReducer.currentBookingId,
    locationToGoToFromCustomerPageModal:
      state.menuReducer.locationToGoToFromCustomerPageModal,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData
  };
}
